import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import env from 'Env';

const Captcha = ({ name, timeout, onChange, resetRef }) => {
  const [loaded, setLoaded] = useState(false);
  const [recaptchaId, setRecaptchaId] = useState(null);
  const hasStartedRendering = useRef(false);
  const loadedRecaptcha = useSelector(state => state?.recaptcha?.loaded);

  useEffect(() => {
    if (!loadedRecaptcha) {
      const recaptchaScript = document.createElement('script');

      recaptchaScript.src = `https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoadCallback&render=${env.gcp.reCaptcha3PublicKey}`;
      recaptchaScript.async = true;
      recaptchaScript.defer = true;

      document.body.appendChild(recaptchaScript);
    }
  }, [loadedRecaptcha]);


  useEffect(() => {
    if (loadedRecaptcha && !hasStartedRendering.current && !recaptchaId) {
      hasStartedRendering.current = true;
      setTimeout(() => {
        const id = grecaptcha.render(name, {
          sitekey: env.gcp.reCaptcha2PublicKey,
          callback: onChange,
        });
        setRecaptchaId(id);
        setLoaded(true);
      }, timeout);
    }
  }, [loadedRecaptcha, name, onChange, recaptchaId, timeout]);

  const reset = () => grecaptcha.reset(recaptchaId);

  if (!loadedRecaptcha) return false;

  resetRef(reset);

  return (
    <div
      id={name}
      className={classNames('recaptcha-div fade', { show: loaded })}
    />
  );
};

Captcha.propTypes = {
  resetRef: PropTypes.func,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  timeout: PropTypes.number,
};

Captcha.defaultProps = {
  resetRef: () => {},
  timeout: 500,
};

export default Captcha;
